interface Props {
  width: number;
}

export function DefaultTeamLogo({ width }: Props) {
  return (
    <svg
      width={width}
      viewBox="0 0 118 80"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <rect
        x="0.5"
        y="0.5"
        width="117"
        height="79"
        rx="4.5"
        fill="#F5F5F5"
        stroke="#EEEEEE"
      />
      <path
        d="M112.621 75.5918C113.872 76.8542 112.978 79 111.2 79H6.92346C5.12842 79 4.24219 76.8184 5.52873 75.5666L29.1491 52.584C29.9078 51.8458 31.1103 51.8266 31.8921 52.5402L49.4186 68.5365C50.2013 69.2509 51.4052 69.2308 52.1636 68.4908L77.8927 43.3856C78.6788 42.6186 79.9363 42.6289 80.7097 43.4088L112.621 75.5918Z"
        fill="#E0E0E0"
      />
      <circle cx="100.5" cy="13.5" r="5.5" fill="#E0E0E0" />
    </svg>
  );
}
